import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Context from '../../../store/context';
import { ReactComponent as ArrowUpRight } from '../../../assets/icons/ArrowUpRight.svg';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import apiMethods from '../../../apis';
import useGet from '../../../services/hooks/http/useGet';
import { paths } from '../../../routes';
import utils from '../../../services/utils';
import DetailBank from '../../CardBankPayout/DetailBank/DetailBank';
import ListInvoices from '../../Cards/SupplierAndInvoiceCard/ListInvoices/ListInvoices';
import InvoiceDetail from '../../Details/InvoiceDetail/InvoiceDetail';
import HeadPay from '../../ResultPay/HeadPay/HeadPay';
import PurchasesResult from '../../ResultPay/PurchasesResult/PurchasesResult';
import NoticeCard from '../../NoticeCard/NoticeCard';
import Button from '../../Buttons/Button/Button';

import classes from './ResultPayPurchases.module.scss';

const ResultPayPurchases = ({ payPurchasesData, route, methodForPay, costTransaction }) => {
  const navigate = useNavigate();
  const { businessId } = useSelector(state => state.userData);

  const {
    modal: { showError, showModal }
  } = useContext(Context);

  const [fetchGetState, setFetchGetState] = useState(false);

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getPurchasesPayoutVoucher, [businessId, payPurchasesData.payoutId], fetchGetState);

  const downloadVoucher = () => {
    setFetchGetState(true);
  };

  const goInvoicesView = () => {
    // Navegar al historial de pagos donde se pueden ver los pagos en proceso
    navigate(paths.paymentHistory);
  };

  const goHome = () => {
    navigate(paths.home);
  };

  useEffect(() => {
    if (getPayedVoucherSuccess) {
      utils.downloadFileByUrl(getPayedVoucher);
      setFetchGetState(false);
    } else if (getPayedVoucherError) {
      showError({ title: 'Comprobante de pago', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  const showDetails = (iconBank, subtypeLabel, bankLast4Digits, owner, identification) => {
    showModal(
      <DetailBank
        bank={iconBank}
        subtypeLabel={subtypeLabel}
        bankNumber={`****${bankLast4Digits}`}
        name={owner}
        identification={identification}
      />
    );
  };

  const showInvoiceDetail = (purchasesItems, supplierName, totalValue, data) => {
    if (purchasesItems.length > 1) {
      showModal(<ListInvoices supplierName={supplierName} purchasesItems={purchasesItems} totalValue={totalValue} />);
    } else {
      const payedValue = data.payments.reduce((prev, payment) => prev + payment.value, 0);
      showModal(
        <InvoiceDetail
          invoice={{
            ...data,
            totalValue: data.payableAmountAfterRetentions,
            payedValue,
            pendingValue: data.payableAmountAfterRetentions - payedValue
          }}
          supplier={supplierName}
        />
      );
    }
  };

  return (
    <div className={classes.container}>
      <HeadPay
        totalToPay={payPurchasesData.totalValue}
        text={`${payPurchasesData.totalPurchases} cuentas de cobro de ${payPurchasesData.totalSuppliers} proveedores`}
      />
      <div className={`${classes.card} card-formGrid`}>
        <PurchasesResult
          view='payout'
          showDetails={showDetails}
          showInvoiceDetail={showInvoiceDetail}
          payPurchasesData={payPurchasesData}
          methodForPay={methodForPay}
          costTransaction={costTransaction}
        />
        <NoticeCard
          className={classes.notice}
          text='Una vez el pago sea aprobado (máx. 1 día hábil), automáticamente se te enviará a ti y a todos los proveedores, un correo de confirmación del pago con los detalles.'
        />
      </div>

      <div className={classes.buttons}>
        <Button onClick={downloadVoucher} Icon={ArrowDownLine}>
          Descargar comprobante
        </Button>
        <Button className={classes.button} Icon={ArrowUpRight} custom='secondary' onClick={goInvoicesView}>
          Ir a Historial de pagos
        </Button>
        <Button className={classes.button} custom='tertiary' onClick={goHome}>
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default ResultPayPurchases;
